import { useEffect } from 'react'

// Adds a CSS class to body rather than mutating inline styles, which is
// easier to reason about and avoids conflicts with other style rules.
export function useScrollLock(isLocked: boolean) {
  useEffect(() => {
    document.body.classList.toggle('scroll-lock', isLocked)
    return () => {
      document.body.classList.remove('scroll-lock')
    }
  }, [isLocked])
}
